import React from 'react'
import { Link } from 'react-router-dom'
import useOrderTracking from '../../../hooks/useOrderTracking'
import { Return } from '../../../utils/order-status/interfaces'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('OrderStatus')

type OrderStatusProps = {
    externalOrderId: string
    orderStatus: string
    countryCode: string
    messages: any
    trackShippingButton?: React.ReactNode
    viewDetailLink: string
    alwaysShowOrderStatus?: boolean
    deliveryTrackingEnabled?: boolean
    shippingMethod: Array<string>
    returns: Array<Return>
    isPartialReturnRefused: boolean,
    handleTrackOrderClick: () => void
}

const OrderItemStatus: React.FC<OrderStatusProps> = ({
    externalOrderId,
    orderStatus,
    countryCode,
    messages,
    trackShippingButton,
    viewDetailLink,
    alwaysShowOrderStatus,
    deliveryTrackingEnabled,
    shippingMethod,
    returns,
    isPartialReturnRefused,
    handleTrackOrderClick
}) => {
    const { orderPrimaryStatus } = useOrderTracking({
        orderStatus,
        orderId: externalOrderId,
        trackingNumber: '',
        orderInformation: {
            timeDelivered: '',
            dateShipped: '',
            shippingCountry: countryCode,
            shippingMethod,
            isReturn: returns?.length > 0,
            isPartialReturnRefused
        }
    })

    const status = orderPrimaryStatus.status || orderStatus
    let children = trackShippingButton || status

    if (status === 'Pending') {
        children = messages.orderStatus.pending()
    } else if (alwaysShowOrderStatus) {
        children = status
    } else if (!!trackShippingButton && deliveryTrackingEnabled) {
        children = (
            <Link
                className={bem('trackLink')}
                to={`${viewDetailLink}/track`}
                onClick={handleTrackOrderClick}
            >
                {messages.orderDetails.trackOrder()}
            </Link>
        )
    }

    return <div className={bem(null)}>{children}</div>
}

export default OrderItemStatus
